import { render, staticRenderFns } from "./SeriesBrandsTbl.vue?vue&type=template&id=2d3e3c9c&scoped=true&"
import script from "./SeriesBrandsTbl.vue?vue&type=script&lang=js&"
export * from "./SeriesBrandsTbl.vue?vue&type=script&lang=js&"
import style0 from "./SeriesBrandsTbl.vue?vue&type=style&index=0&id=2d3e3c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e3c9c",
  null
  
)

export default component.exports